// Compact dropdown UI for a real product option (e.g. Grind on Spicy Robusta -
// NEW 2) - the underlying radio inputs/labels stay in the DOM (hidden) so
// native variant switching keeps working; the dropdown just proxies clicks
// to the matching hidden label.
//
// Shared across every product-form template that can render this dropdown
// (see snippets/product-variant-options.liquid's use_grind_dropdown) -
// include this file wherever product-variant-picker/product-variant-options
// is rendered, so the dropdown isn't just markup with no interactivity.
document.querySelectorAll("[data-variant-grind-dropdown]").forEach(function (dropdown) {
  var trigger = dropdown.querySelector(".grind-dropdown__trigger");
  var panel = dropdown.querySelector(".grind-dropdown__panel");
  var label = dropdown.querySelector("[data-grind-label]");
  var iconWrap = dropdown.querySelector("[data-grind-icon]");
  if (!trigger || !panel) return;

  // The product card this dropdown lives in has `overflow: hidden` (to round
  // its corners), which clips the open panel and hides its last option(s).
  // While open, move the panel to <body> and position it with `fixed`
  // coordinates so it renders outside that clipping ancestor.
  var panelAnchor = document.createComment("grind-dropdown-panel-anchor");
  panel.parentNode.insertBefore(panelAnchor, panel);

  function positionPanel() {
    var rect = dropdown.getBoundingClientRect();
    panel.style.position = "fixed";
    panel.style.top = rect.bottom + 8 + "px";
    panel.style.left = rect.left + "px";
    panel.style.width = rect.width + "px";
    panel.style.zIndex = "999";
  }

  function openPanel() {
    document.body.appendChild(panel);
    positionPanel();
    trigger.setAttribute("aria-expanded", "true");
    panel.classList.remove("hidden");
  }

  function closePanel() {
    trigger.setAttribute("aria-expanded", "false");
    panel.classList.add("hidden");
    if (panel.parentNode === document.body) {
      panelAnchor.parentNode.insertBefore(panel, panelAnchor);
      panel.style.position = "";
      panel.style.top = "";
      panel.style.left = "";
      panel.style.width = "";
      panel.style.zIndex = "";
    }
  }

  trigger.addEventListener("click", function () {
    var expanded = trigger.getAttribute("aria-expanded") === "true";
    if (expanded) {
      closePanel();
    } else {
      openPanel();
    }
  });

  document.addEventListener("click", function (event) {
    if (!dropdown.contains(event.target) && !panel.contains(event.target)) {
      closePanel();
    }
  });

  window.addEventListener("resize", function () {
    if (trigger.getAttribute("aria-expanded") === "true") positionPanel();
  });
  window.addEventListener(
    "scroll",
    function () {
      if (trigger.getAttribute("aria-expanded") === "true") positionPanel();
    },
    true
  );

  dropdown.querySelectorAll(".grind-dropdown__option").forEach(function (option) {
    option.addEventListener("click", function (event) {
      event.stopPropagation();
      var targetId = option.dataset.grindTarget;
      var targetLabel = targetId && document.querySelector('label[for="' + targetId + '"]');
      if (targetLabel) targetLabel.click();
      if (label) label.textContent = option.textContent.trim();
      if (iconWrap) {
        var optionIcon = option.querySelector("img");
        iconWrap.innerHTML = optionIcon ? optionIcon.outerHTML : "";
      }
      closePanel();
    });
  });
});
